import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import { X } from 'lucide-react';

export function Modal({ open, onClose, title, children, maxWidth = 540, titleId }) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prev;
            window.removeEventListener('keydown', onKey);
        };
    }, [open, onClose]);

    if (!open) return null;

    return createPortal(
        <div className="modal-backdrop" onClick={onClose} role="presentation">
            <div
                className="modal"
                style={{ maxWidth }}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
            >
                {(title || onClose) && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                        {title ? (
                            <h2 id={titleId} className="headline" style={{ fontSize: '1.6rem', margin: 0 }}>{title}</h2>
                        ) : <div />}
                        <button type="button" className="modal-close" onClick={onClose} aria-label="Închide">
                            <X size={18} />
                        </button>
                    </div>
                )}
                {children}
            </div>
        </div>,
        document.body
    );
}
